/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Column_SubmittedInputs */

const en_admin_user_detail_column_submitted = /** @type {(inputs: Admin_User_Detail_Column_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

const de_admin_user_detail_column_submitted = /** @type {(inputs: Admin_User_Detail_Column_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht`)
};

/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {Admin_User_Detail_Column_SubmittedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_column_submitted = /** @type {((inputs?: Admin_User_Detail_Column_SubmittedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Column_SubmittedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_column_submitted(inputs)
	return en_admin_user_detail_column_submitted(inputs)
});